import { render } from "./ViewCscreComponent.vue?vue&type=template&id=13a70a43"
import script from "./ViewCscreComponent.vue?vue&type=script&lang=js"
export * from "./ViewCscreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__